import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Shell Companies',
		description:
			"Create a maze of shell companies so complex even you don't know where the money goes."
	},
	{
		name: 'Offshore Everything',
		description:
			'Move all operations to a mysterious island that may or may not exist.'
	},
	{
		name: 'Creative Accounting',
		description:
			'Hire accountants who think math is more of an art than a science.'
	},
	{
		name: 'Quantum Donations',
		description: "Money simultaneously exists and doesn't exist until audited."
	},
	{
		name: 'Time-Traveling Funds',
		description:
			"Receive donations from the future. Hope future inflation isn't too bad."
	},
	{
		name: 'Parallel Universe Funding',
		description: 'Accept campaign contributions from alternate reality donors.'
	},
	{
		name: 'Void Banking',
		description:
			'Store campaign funds in the void. Perfect for avoiding those pesky audits.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Super PACs'],
	departments[DepartmentIds['Super PACs']].basePrice * 3,
	UpgradeIds.SpcExponent1
)

export default array
